import { render, staticRenderFns } from "./ReceipesSpecial.vue?vue&type=template&id=818466d2&"
import script from "./ReceipesSpecial.vue?vue&type=script&lang=js&"
export * from "./ReceipesSpecial.vue?vue&type=script&lang=js&"
import style0 from "./ReceipesSpecial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports